import React, { useState } from "react";
import ModalV2 from "../../../../../shared/components/modalV2";

interface SubmitTransferModalProps {
  isOpen: boolean;
  onClose: () => void;
  onClick: () => void;
}

function SubmitTransferModal({
  isOpen,
  onClose,
  onClick,
}: SubmitTransferModalProps) {
  const [selectedJudge, setSelectedJudge] = useState<"admin" | "chief">(
    "chief",
  );

  return (
    <ModalV2
      isOpen={isOpen}
      isClose={onClose}
      maxWidth="w-[458px]"
      edges="rounded-xl"
    >
      <div className="w-full py-8 px-10 flex flex-col gap-y-6">
        <div className="w-full flex flex-col items-center justify-center gap-y-4">
          <span className="text-[#101828] text-xl font-bold text-center leading-normal">
            Are you ready to submit this files for service?
          </span>
        </div>

        <div className="flex flex-col gap-4">
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="radio"
              name="judge"
              value="admin"
              checked={selectedJudge === "admin"}
              onChange={() => setSelectedJudge("admin")}
              className="w-5 h-5 border-2 border-[#D0D5DD] text-[#00B074] focus:ring-[#00B074]"
            />
            <div className="flex items-center gap-2">
              <span className="text-sm text-[#101828]">Admin Judge</span>
              <span className="w-4 h-4 rounded-full border border-[#D0D5DD] flex items-center justify-center text-[10px] text-[#667085]">
                i
              </span>
              <span className="px-3 py-1 rounded-full bg-[#F2F4F7] text-[11px] text-[#667085]">
                Default
              </span>
            </div>
          </label>

          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="radio"
              name="judge"
              value="chief"
              checked={selectedJudge === "chief"}
              onChange={() => setSelectedJudge("chief")}
              className="w-5 h-5 border-2 border-[#D0D5DD] text-[#00B074] focus:ring-[#00B074]"
            />
            <span className="text-sm text-[#101828]">Chief Judge</span>
          </label>
        </div>

        <div className="w-full flex items-center gap-3 pt-2">
          <button
            onClick={onClose}
            className="w-full bg-[#ECFDF3] rounded-lg p-3 text-[16px] font-medium text-[#027A48] hover:bg-[#D1FADF] transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onClick}
            className="w-full bg-[#00B074] rounded-lg p-3 text-[16px] font-medium text-white hover:bg-[#009060] transition-colors"
          >
            Submit
          </button>
        </div>
      </div>
    </ModalV2>
  );
}

export default SubmitTransferModal;
